module.exports = __webpack_public_path__ + "static/codacy-daac85c31040f3eb25dcfad481966653.png";